<template>
  <div>
    <validation-observer ref="UserFormValidator">
      <v-form>
        <v-card>
          <v-card-title>{{ $route.params.id ? 'ユーザ編集' : 'ユーザ追加' }}</v-card-title>
          <v-card-text>
            <!-- 氏名 -->
            <v-row>
              <v-col cols="12" md="9">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|max:50"
                  name="氏名"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="user.name"
                    :error-messages="errors"
                    label="氏名"
                    hide-details="auto"
                    persistent-placeholder
                    required
                  > 
                    <template v-slot:label>
                      <span>氏名</span>
                      <span class="ml-1">
                        ({{ user.name?.length || 0 }} / 50)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /氏名 -->

            <!-- メールアドレス -->
            <v-row>
              <v-col cols="12" md="9">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|email|max:100"
                  name="メールアドレス"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="user.email"
                    :error-messages="errors"
                    autocomplete="off"
                    label="メールアドレス"
                    hide-details="auto"
                    persistent-placeholder
                    required
                  >
                    <template v-slot:label>
                      <span>メールアドレス</span>
                      <span class="ml-1">
                        ({{ user.email?.length || 0 }} / 100)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /メールアドレス -->

            <!-- ログインID -->
            <v-row>
              <v-col cols="12" md="9">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|max:254"
                  name="ログインID"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="user.login_id"
                    :error-messages="errors"
                    autocomplete="off"
                    hide-details="auto"
                    label="ログインID"
                    persistent-placeholder
                    required
                  >
                    <template v-slot:label>
                      <span>ログインID</span>
                      <span class="ml-1">
                        ({{ user.login_id?.length || 0 }} / 254)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /ログインID -->

            <!-- パスワード -->
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  vid="password"
                  rules="max:20"
                  name="パスワード"
                >
                  <v-text-field
                    v-model="user.password"
                    :error-messages="errors"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    hide-details="auto"
                    label="パスワード"
                    autocomplete="new-password"
                    persistent-placeholder
                    @click:append="showPassword = !showPassword"
                  > 
                    <template v-slot:label>
                      <span>パスワード</span>
                      <span class="ml-1">
                        ({{ user.password?.length || 0 }} / 20)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ required: user.password !== user.password_confirmation, confirmed: 'password' }"
                  name="パスワード"
                >
                  <v-text-field
                    v-model="user.password_confirmation"
                    :error-messages="errors"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    autocomplete="new-password"
                    hide-details="auto"
                    label="パスワード（確認用）"
                    required
                    persistent-placeholder
                    @click:append="showConfirmPassword = !showConfirmPassword"
                  >
                    <template v-slot:label>
                      <span>パスワード（確認用）</span>
                      <span class="ml-1">
                        ({{ user.password_confirmation?.length || 0 }} / 20)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /パスワード -->

            <!-- ロール -->
            <v-row>
              <v-col cols="4">
                <v-select
                  v-model="user.role"
                  :items="roles"
                  label="ロール"
                  hide-details="auto"
                  persistent-placeholder
                />
              </v-col>
            </v-row>
            <!-- /ロール -->
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'UserForm',
  components: {},
  mixins: [],
  data () {
    return {
      showPassword: false,
      showConfirmPassword: false,
      roles: [],
      user: {
        id: null,
        name: null,
        email: null,
        login_id: null,
        role: 'editor',
        password: null,
        password_confirmation: null,
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.editAdminUser({ id: this.$route.params.id }).then((content) => {
        this.user = content
        this.roles = content.roles
      })
    } else {
      this.newAdminUser().then((content) => {
        this.user = content
        this.roles = content.roles
      })
    }
  },
  methods: {
    ...mapActions('AdminUser', {
      newAdminUser: 'new',
      editAdminUser: 'edit',
      createAdminUser: 'create',
      updateAdminUser: 'update'
    }),
    registerButtonClickEvent () {
      let $self = this
      this.$refs.UserFormValidator.validate().then((result) => {
        if(result){
          $self.sendRegistrationInformation()
        }
      })

    },
    sendRegistrationInformation () {
      if (this.user.id) {
        this.updateAdminUser({ id: this.user.id, params: this.user }).then(() => {
          this.$router.push( { name: 'AdminUsers' } )
        })
      } else {
        this.createAdminUser({ params: this.user }).then(() => {
          this.$router.push( { name: 'AdminUsers', params: { resetPagination: true }  } )
        })
      }
    },
  }
}
</script>
